const constants = {
  GENDER: {
    male: 'male',
    female: 'female',
  },
  TIME_FORMAT: 'HH:mm',
  DATE_FORMAT: 'DD/MM/YYYY',
  DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
};

export default constants;
